function isInputEmpty(input: string): boolean {
    const isEmpty = !input.trim().length;
    return isEmpty;
}

export default isInputEmpty;
